import {
  sampleDrawLayer,
  samplePointLayer,
} from 'components/MapComponent/constants/sampleLayers';
import { apiPrefix } from 'constants/apiConfig';
import { LayerConfiguration } from './mapEventsEffectTypes';

export const custom_polygon_events_layer_id = 'custom_polygon_events_layer_id';
export const custom_point_events_layer_id = 'custom_point_events_layer_id';
export const custom_polygon_events_source_id =
  'custom_polygon_events_source_id';
export const custom_point_events_source_id = 'custom_point_events_source_id';
export const custom_polygon_source_layer = 'public.custom_polygon_events_layer';
export const custom_point_source_layer = 'public.custom_point_events_layer';

export function addCustomEventsLayers({
  addMapEventHandlers,
  addVectorSource,
  group_guid,
}: {
  addMapEventHandlers: (layerConfig: LayerConfiguration) => void;
  addVectorSource: (sourceId: string, tiles: string) => void;
  group_guid: UUID;
}) {
  const customPolygonTiles = `${apiPrefix}/event_tiles/${custom_polygon_source_layer}/{z}/{x}/{y}.pbf`;
  const polygonTilesPath = `${customPolygonTiles}?arg_group_guid=${group_guid}`;

  addVectorSource(custom_polygon_events_source_id, polygonTilesPath);

  const customPointTiles = `${apiPrefix}/event_tiles/${custom_point_source_layer}/{z}/{x}/{y}.pbf`;
  const customPointTilesPath = `${customPointTiles}?arg_group_guid=${group_guid}`;

  addVectorSource(custom_point_events_source_id, customPointTilesPath);

  const customPolygonEventsLayerConfig = {
    ...sampleDrawLayer,
    id: custom_polygon_events_layer_id,
    source: custom_polygon_events_source_id,
    'source-layer': custom_polygon_source_layer,
    generateId: true,
    paint: {
      'fill-color': '#FFFFFF',
      'fill-opacity': 0.6,
    },
    metadata: {
      eventlayer: true,
      usermade: undefined,
    },
  };

  const customPointEventsLayerConfig = {
    ...samplePointLayer,
    id: custom_point_events_layer_id,
    source: custom_point_events_source_id,
    'source-layer': custom_point_source_layer,
    generateId: true,
    paint: {
      'circle-color': '#FFFFFF',
      'circle-radius': 5,
    },
    metadata: {
      eventlayer: true,
      usermade: undefined,
    },
  };

  addMapEventHandlers(customPolygonEventsLayerConfig);

  addMapEventHandlers(customPointEventsLayerConfig);
}

export function removeCustomEventsLayers({
  removeLayer,
  removeSource,
}: {
  removeLayer: (layerId: string) => void;
  removeSource: (sourceId: string) => void;
}) {
  removeLayer(custom_polygon_events_layer_id);
  removeLayer(custom_point_events_layer_id);

  removeSource(custom_polygon_events_source_id);
  removeSource(custom_point_events_source_id);
}

export function setCustomEventsLayersVisibility({
  setLayerVisibility,
  isVisible,
}: {
  setLayerVisibility: (layerId: string, isVisible: boolean) => void;
  isVisible: boolean;
}) {
  setLayerVisibility(custom_polygon_events_layer_id, isVisible);
  setLayerVisibility(custom_point_events_layer_id, isVisible);
}
